import router from '../router';
import { directusApi } from '@/api';

export interface AuthDTO {
    email: string;
    password: string;
}

export interface User {
    id?: number;
    email: string;
}

const state = {
    currentUser: null,
    currentUserLoading: false,
};

const mutations = {
    TOGGLE_CURRENT_USER_LOADING(state: any, data: boolean) {
        state.currentUserLoading = data;
    },
    SET_TOKENS(state: any, data: any | null) {
        if (data != null) {
            window.localStorage.setItem(process.env.VUE_APP_DIRECTUS_ACCESS_TOKEN, data.access_token);
            window.localStorage.setItem(process.env.VUE_APP_DIRECTUS_REFRESH_TOKEN, data.refresh_token);
        } else {
            window.localStorage.removeItem(process.env.VUE_APP_DIRECTUS_ACCESS_TOKEN);
            window.localStorage.removeItem(process.env.VUE_APP_DIRECTUS_REFRESH_TOKEN);
        }
    },
    SET_CURRENT_USER(state: any, user: any | null) {
        state.currentUser = user;
    },
};

const actions = {
    async login({ state, _, commit, dispatch }: any, { vm, payload }) {
        let body = {};
        let endpoint = '';
        let fromLogin = false;
        let refresh_token = window.localStorage.getItem(process.env.VUE_APP_DIRECTUS_REFRESH_TOKEN);

        if (payload != null) {
            fromLogin = true;
            commit('SET_TOKENS', null);
            commit('SET_CURRENT_USER', null);
            body = payload;
            endpoint = 'auth/login';
        } else if (refresh_token) {
            body = { refresh_token };
            endpoint = 'auth/refresh';
        }

        commit('TOGGLE_CURRENT_USER_LOADING', true);

        await directusApi('POST', endpoint, body)
            .then(async response => {
                commit('SET_TOKENS', { access_token: response.data.data.access_token, refresh_token: response.data.data.refresh_token });

                await directusApi('GET', `users/me?fields=*,role.*`)
                    .then(response => {
                        // console.log('SET_CURRENT_USER', response.data.data);
                        commit('SET_CURRENT_USER', response.data.data);

                        if (fromLogin) {
                            setTimeout(() => {
                                router.push('products');
                            }, 500);
                        }
                    })
                    .catch(error => {
                        commit('SET_CURRENT_USER', null);
                        commit('SET_TOKENS', null);
                        if (fromLogin) {
                            vm.$bvToast.toast(error.response.data.errors[0].message, {
                                title: `Atención`,
                                variant: 'danger',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        }
                        console.log(error.response.data);
                    })
                    .finally(() => {
                        commit('TOGGLE_CURRENT_USER_LOADING', false);
                    });
            })
            .catch(error => {
                if (fromLogin) {
                    vm.$bvToast.toast(error.response.data.errors[0].message, {
                        title: `Atención`,
                        variant: 'danger',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                }
                console.log(error.response.data);
                commit('SET_CURRENT_USER', null);
                commit('SET_TOKENS', null);
            })
            .finally(() => {
                commit('TOGGLE_CURRENT_USER_LOADING', false);
            });
    },
    async logout({ _, commit }: any) {
        commit('TOGGLE_CURRENT_USER_LOADING', true);
        commit('SET_CURRENT_USER', null);
        commit('SET_TOKENS', null);
        commit('TOGGLE_CURRENT_USER_LOADING', false);
        setTimeout(() => {
            router.push('login');
        }, 500);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
